/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { QueryGraphQL } from "../../../../../Queries/GraphQl";
import Common from "../../../../../../Utils/Common";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { setHeaderTranparentAction } from "../../../../../Actions/Layout";
import { useMount, useSetState, useUnmount } from "react-use";
import { Observable, Observer } from "../../../../../../Utils/Ob";
import MCC from "../../../../ComponentCommon/MiddleContent";
import _ from "lodash";
import { Skeleton, Empty, Spin, Pagination } from "antd";
import { SpinIcon } from "../../../../ComponentCommon/PageLoading";
import Configuration from "../../../../../../Config/Config";
import SubcribeCategory from "../../../../ComponentCommon/Box/maxcoach/SubcribeCategory";
import Breadcrumb from "../../../../ComponentCommon/maxcoach/Breadcrumb";
import { useTranslation } from "react-i18next";

// Chuyển page khác vẫn lưu trạng thái.
const data = Observable({
  waitForSubscribe: {},
});

function Blog(props) {
  const { t } = useTranslation();
  const [state, setState] = useSetState({
    newestArticles: [],
    allArticleByCate: [],
    popularArticle: [],
    toplatestArticle: 9,
    offset: 0,
    totalItem: null,
    itemPerPage: 4,
    arrayItemPerPage: [],
    currentCategory: null,
    categories: [],
    merchants: [
      {
        id: "86a050ba-72a6-4d93-8fad-bc037c6b94c7",
        image:
          "https://static1.izzi.asia//images/2020/1/17/2001174760_IZZIMeeting200114.32048px.jpg?mode=crop&width=1920&height=1100",
        name: "Trịnh Minh Giang Blog",
        link: "https://trinhminhgiang.com/",
      },
      {
        id: "d5f161d2-32f3-4f03-a30c-2e8536a8da44",
        image:
          "https://static.izzi.asia/images/2019/12/27/1912277668_wave.ngsversion.1500050062134.adapt.1900.1.jpg",
        name: "Học viện Strategyacademy",
        link: "https://strategyacademy.vn/",
      },
    ],
    loadingTrend: false,
    currentPage: 0,
    loadingFollow: false,
    changeCategory: false,
  });

  const _subcribe = (id) => {
    if (data.waitForSubscribe[id]) return;

    const updateState = (value) => {
      let temp = _.cloneDeep(data.waitForSubscribe);
      temp[id] = value;
      data.waitForSubscribe = temp;
    };

    updateState(true);
    Common.sendSyncCommand(
      "AddTargetUser",
      "User",
      {
        Id: props.infoUser.id,
        TargetId: id,
        TargetEntity: 80,
      },
      () => {
        updateState(false);
        Swal.fire("Theo dõi thành công.");
      },
      () => {
        updateState(false);
        Swal.fire("Thông tin theo dõi cập nhật thất bại!");
      }
    );
  };
  const _paginate = (indexPage, noAutoScroll) => {
    let offset = state.itemPerPage * indexPage;
    setState({ offset, loadingFollow: true, currentPage: indexPage });
    QueryGraphQL.getSubcribeArticles(0, offset, state.itemPerPage, state.currentCategory).then(
      (data) => {
        if (data.subcribearticlesbycategory.items.length) {
          setState({
            arrayItemPerPage: data.subcribearticlesbycategory.items,
            totalItem: data.subcribearticlesbycategory.totalCount,
          });
          if (!noAutoScroll)
            setTimeout(() => document.getElementById("follow-categories").scrollIntoView());
        }
        setState({ loadingFollow: false, changeCategory: false });
      }
    );
  };
  const _init = () => {
    setState({ loadingTrend: true, currentPage: 0 });
    QueryGraphQL.getSubcribeArticles(0, 0, 5, "")
      .then((data) => {
        setState({
          newestArticles: data.subcribearticlesbycategory.items,
          loadingTrend: false,
        });
      })
      .catch(() => {
        setState({
          loadingTrend: false,
        });
      });
    window.showPageLoading();
    QueryGraphQL.getSubcribeCategories()
      .then((data) => {
        window.hidePageLoading();
        if (data.subcribecategories.items.length) {
          window.showPageLoading();
          let currentCategory = data.subcribecategories.items.slice(0, 1)[0].id;
          setState({
            categories: data.subcribecategories.items,
            currentCategory,
          });
          QueryGraphQL.getSubcribeArticles(0, state.offset, state.itemPerPage, currentCategory)
            .then((data) => {
              window.hidePageLoading();
              if (data.subcribearticlesbycategory.items.length) {
                setState({
                  totalItem: data.subcribearticlesbycategory.totalCount,
                  arrayItemPerPage: data.subcribearticlesbycategory.items,
                  popularArticle: data.subcribearticlesbycategory.items.slice(0, 3),
                });
              }
            })
            .catch(() => {
              window.hidePageLoading();
            });
        }
      })
      .catch(() => {
        window.hidePageLoading();
      });
  };

  useUnmount(() => {
    window.resetPageLoading();
  });
  useMount(() => {
    _init();
  });
  useEffect(() => {
    if (state.currentCategory) _paginate(0, true);
  }, [state.currentCategory]);

  let pageTitle = "Followed Categories";

  return (
    <React.Fragment>
      <div className="page-title-section section">
        <div className="page-title">
          <div className="container">
            <h3 className="title">{t(pageTitle)}</h3>
          </div>
        </div>
        <Breadcrumb items={[{ name: "Home", href: "/" }, { name: pageTitle }]} />
      </div>
      <div className="section section-padding-bottom">
        <div className="container">
          <div className="row max-mb-n50">
            <div className="col-lg-8 col-12 order-lg-1 max-mb-50">
              <div
                className="sidebar-widget-wrapper pr-0 animate__animated animate__fadeInUp animate__faster"
                hidden={window.isPageLoading()}>
                <div className="sidebar-widget">
                  <h3 className="sidebar-widget-title text-center">{t("Authors")}</h3>
                  <div className="sidebar-widget-content">
                    <div className="section" style={{ paddingBottom: 50 }}>
                      <div className="container">
                        <div className="row row-cols-lg-3 row-cols-md-2 row-cols-1 max-mb-n30">
                          {state.merchants.map((item, i) => (
                            <div
                              key={i}
                              className="col max-mb-30 animate__animated animate__fadeInUp">
                              <div className="event">
                                <div className="thumbnail">
                                  <Link
                                    to={"/"}
                                    className="image"
                                    onClick={(e) => e.preventDefault()}>
                                    <span
                                      style={{
                                        display: "inline-block",
                                        minHeight: 150,
                                        height: 150,
                                        width: "100%",
                                        background: "#C3C3C3",
                                      }}>
                                      <MCC>
                                        <img src={item.image} alt={item.name} />
                                      </MCC>
                                    </span>
                                  </Link>
                                </div>
                                <div className="info">
                                  <h3 className="title">
                                    <Link to={"/"} onClick={(e) => e.preventDefault()}>
                                      {item.name}
                                    </Link>
                                  </h3>
                                  <button
                                    className="btn btn-width-100 btn-primary"
                                    style={{ marginTop: 30 }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      _subcribe(item.id);
                                    }}>
                                    {data.waitForSubscribe[item.id] ? (
                                      <Spin indicator={SpinIcon} style={{ color: "#FFFFFF" }} />
                                    ) : (
                                      <span>{t("Follow")}</span>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sidebar-widget">
                  <h3
                    className="sidebar-widget-title text-center"
                    style={{
                      position: "relative",
                    }}>
                    {t("Following Categories")}
                    <div
                      style={{
                        position: "absolute",
                        top: -150,
                      }}
                      id={"follow-categories"}
                    />
                  </h3>
                  <div className="section" style={{ marginBottom: 30 }}>
                    <div className="container">
                      <div
                        className="tagcloud animate__animated animate__fadeIn"
                        style={{ textAlign: "center" }}>
                        <Spin indicator={SpinIcon} spinning={state.changeCategory}>
                          {state.categories.map((categoryInfo, i) => {
                            return (
                              <Link
                                key={i}
                                to={"/"}
                                className={
                                  categoryInfo.id === state.currentCategory
                                    ? "active-category"
                                    : undefined
                                }
                                style={{ float: "unset", display: "inline-block" }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setState({
                                    currentCategory: categoryInfo.id,
                                    changeCategory: true,
                                  });
                                }}>
                                {categoryInfo.name}
                              </Link>
                            );
                          })}
                        </Spin>
                      </div>
                    </div>
                  </div>
                  <div className="sidebar-widget-content">
                    <div className="section">
                      <div className="container">
                        {state.arrayItemPerPage.length === 0 && (
                          <div style={{ textAlign: "center", height: "calc(100vh / 4)" }}>
                            <MCC>
                              <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description={"Cần chọn chuyên mục theo dõi."}
                              />
                            </MCC>
                          </div>
                        )}
                        <div className="row row-cols-1 no-gutters">
                          {state.arrayItemPerPage.map((item, i) => (
                            <div className="blog-3 col" data-aos="fade-up" key={i}>
                              <div className="row row-cols-lg-2 row-cols-1 max-mb-n30">
                                <div className="col max-mb-30">
                                  <div className="thumbnail">
                                    <Link
                                      to={"/"}
                                      onClick={(e) => e.preventDefault()}
                                      className="image">
                                      <img
                                        src={Common.getImageThumbnail(
                                          item.images,
                                          Configuration.imageFormatBlogMaxcoach
                                        )}
                                        alt={"Thumbnail"}
                                      />
                                    </Link>
                                  </div>
                                </div>
                                <div className="col max-mb-30">
                                  <div className="info pt-0">
                                    <h4 className="title">
                                      <Link
                                        to={
                                          "/blog/" + item.id + "/" + Common.rewriteUrl(item.name)
                                        }>
                                        {Common.formatName(item.name, 75).toLowerCase()}
                                      </Link>
                                    </h4>
                                    <ul className="meta">
                                      <li>
                                        <i className="far fa-calendar" />
                                        {Common.formatDateTime(
                                          item.createdDate || new Date(),
                                          "dd-mm-yyyy"
                                        )}
                                      </li>
                                    </ul>
                                    <div className="desc">
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html: Common.formatName(item.subDescription || "", 150),
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="row max-mt-50">
                          <div className="col">
                            <ul className="pagination center" style={{ whiteSpace: "nowrap" }}>
                              <Pagination
                                total={state.totalItem}
                                pageSize={state.itemPerPage}
                                showSizeChanger={false}
                                showQuickJumper={state.totalItem / state.itemPerPage > 6}
                                responsive={true}
                                current={state.currentPage + 1}
                                onChange={(pageIndex) => {
                                  _paginate(pageIndex - 1);
                                }}
                                itemRender={(page, type) => {
                                  let renderText = page;
                                  if (type === "prev")
                                    renderText = (
                                      <span style={{ display: "inline-block", marginRight: 16 }}>
                                        Prev
                                      </span>
                                    );
                                  else if (type === "next") renderText = "Next";
                                  return (
                                    <li>
                                      <Link
                                        to={"/"}
                                        onClick={(e) => e.preventDefault()}
                                        className={
                                          page - 1 === state.currentPage && type === "page"
                                            ? "active"
                                            : undefined
                                        }>
                                        {state.currentPage === page - 1 && (
                                          <div>
                                            {state.loadingFollow && type === "page" ? (
                                              <Spin indicator={SpinIcon} />
                                            ) : (
                                              <span>{renderText}</span>
                                            )}
                                          </div>
                                        )}
                                        {state.currentPage !== page - 1 && (
                                          <span>{renderText}</span>
                                        )}
                                      </Link>
                                    </li>
                                  );
                                }}
                              />
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 order-lg-2 max-mb-50" id="sticky-sidebar">
              <div className="sidebar-widget-wrapper pr-0">
                <div className="sidebar-widget">
                  <h3 className="sidebar-widget-title">{t("Follow")}</h3>
                  <div className="sidebar-widget-content">
                    <SubcribeCategory onUpdateSubcrible={_init} />
                  </div>
                </div>
                <div className="sidebar-widget">
                  <div className="sidebar-widget-content">
                    <div className="course-nav-tab">
                      <ul className="nav">
                        <li>
                          <a className="active" data-toggle="tab" href="#news">
                            {t("Newest")}
                          </a>
                        </li>
                        <li>
                          <a data-toggle="tab" href="#trend">
                            {t("Popular")}
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="tab-content">
                      <div id="news" className="tab-pane fade show active">
                        <ul className="sidebar-widget-list-post">
                          {state.newestArticles.map((item, i) => (
                            <li key={i}>
                              <Link to={"/"} onClick={(e) => e.preventDefault()}>
                                {item.name}
                              </Link>
                            </li>
                          ))}
                          {state.loadingTrend && (
                            <li>
                              <Skeleton active={true} />
                            </li>
                          )}
                        </ul>
                      </div>
                      <div id="trend" className="tab-pane fade show">
                        <ul className="sidebar-widget-list-post">
                          {state.newestArticles.map((item, i) => (
                            <li key={i}>
                              <Link to={"/"} onClick={(e) => e.preventDefault()}>
                                {item.name}
                              </Link>
                            </li>
                          ))}
                          {state.loadingTrend && (
                            <li>
                              <Skeleton active={true} />
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    infoUser: state.User.user,
  };
}

const mapDispatchToProps = {
  setHeaderTranparentAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Observer(Blog));
